// Funções de validação para o sistema MeuFiel

export const validators = {
  // Validação de nome
  isValidName: (name) => {
    if (!name || typeof name !== 'string') return false;
    return name.trim().length >= 2 && name.trim().length <= 100;
  },

  // Validação de CPF
  isValidCpf: (cpf) => {
    if (!cpf || typeof cpf !== 'string') return false;
    
    // Remove formatação
    const cleanCpf = cpf.replace(/[^\d]/g, '');
    
    // Verifica se tem 11 dígitos
    if (cleanCpf.length !== 11) return false;
    
    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1{10}$/.test(cleanCpf)) return false;
    
    // Valida dígitos verificadores
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleanCpf.charAt(9))) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleanCpf.charAt(10))) return false;

    return true;
  },

  // Validação de CNPJ
  isValidCnpj: (cnpj) => {
    if (!cnpj || typeof cnpj !== 'string') return false;
    
    // Remove formatação
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');
    
    // Verifica se tem 14 dígitos
    if (cleanCnpj.length !== 14) return false;
    
    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1{13}$/.test(cleanCnpj)) return false;
    
    // Valida primeiro dígito verificador
    let sum = 0;
    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    for (let i = 0; i < 12; i++) {
      sum += parseInt(cleanCnpj.charAt(i)) * weights1[i];
    }
    let remainder = sum % 11;
    const digit1 = remainder < 2 ? 0 : 11 - remainder;
    if (digit1 !== parseInt(cleanCnpj.charAt(12))) return false;

    // Valida segundo dígito verificador
    sum = 0;
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    for (let i = 0; i < 13; i++) {
      sum += parseInt(cleanCnpj.charAt(i)) * weights2[i];
    }
    remainder = sum % 11;
    const digit2 = remainder < 2 ? 0 : 11 - remainder;
    if (digit2 !== parseInt(cleanCnpj.charAt(13))) return false;

    return true;
  },

  // Validação de CPF ou CNPJ
  isValidCpfOrCnpj: (document) => {
    if (!document || typeof document !== 'string') return false;
    
    const cleanDoc = document.replace(/[^\d]/g, '');
    
    if (cleanDoc.length === 11) {
      return validators.isValidCpf(document);
    } else if (cleanDoc.length === 14) {
      return validators.isValidCnpj(document);
    }
    
    return false;
  },

  // Identificar tipo de documento
  getDocumentType: (document) => {
    if (!document || typeof document !== 'string') return null;
    
    const cleanDoc = document.replace(/[^\d]/g, '');
    
    if (cleanDoc.length === 11) {
      return 'cpf';
    } else if (cleanDoc.length === 14) {
      return 'cnpj';
    }
    
    return null;
  },

  // Validação de data de nascimento
  isValidBirthDate: (birthDate) => {
    // Data vazia é válida (campo opcional)
    if (!birthDate || birthDate.trim() === '') return true;
    
    const date = new Date(birthDate);
    
    // Verificar se é uma data válida
    if (isNaN(date.getTime())) return false;
    
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());
    const maxDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
    
    return date >= minDate && date <= maxDate;
  },

  // Validação de email
  isValidEmail: (email) => {
    if (!email || typeof email !== 'string') return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim()) && email.length <= 254;
  },

  // Validação de pontos
  isValidPoints: (points) => {
    const numPoints = parseInt(points);
    return !isNaN(numPoints) && numPoints > 0 && numPoints <= 10000;
  },

  // Validação de descrição
  isValidDescription: (description) => {
    if (!description || typeof description !== 'string') return false;
    return description.trim().length >= 3 && description.trim().length <= 200;
  },

  // Validação de nome da empresa
  isValidCompanyName: (name) => {
    if (!name || typeof name !== 'string') return false;
    return name.trim().length >= 2 && name.trim().length <= 100;
  },

  // Validação de senha
  isValidPassword: (password) => {
    if (!password || typeof password !== 'string') return false;
    return password.length >= 6 && password.length <= 50;
  },

  // Validação de telefone (formato brasileiro)
  isValidPhone: (phone) => {
    if (!phone || typeof phone !== 'string') return false;
    const cleanPhone = phone.replace(/[^\d]/g, '');
    return cleanPhone.length === 10 || cleanPhone.length === 11;
  },

  // Validação de CEP
  isValidCep: (cep) => {
    if (!cep || typeof cep !== 'string') return false;
    const cleanCep = cep.replace(/[^\d]/g, '');
    return cleanCep.length === 8;
  }
};

// Adicionar aliases para compatibilidade
validators.isValidCPF = validators.isValidCpf;